import type { WeatherForecast } from '../api/weather'
import type { Unit } from '../App'
import { WeatherCard } from './WeatherCard'

export function WeatherList({ items, unit }: { items: WeatherForecast[]; unit: Unit }) {
    if (items.length === 0) return <p className="muted">No forecast data.</p>

    return (
        <ul className="forecast">
            {items.map((item) => (
                <WeatherCard key={item.date} forecast={item} unit={unit} />
            ))}
        </ul>
    )
}